<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-19 14:53:38
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div class="comp-dialog">
        <el-dialog
            class="el-dialog-contain prop"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :title="title"
            :visible="visible"
            :width="width"
            :show-close="showClose"
            :before-close="handleBeforeClose"
            @close="onDialogClose"
        >
            <slot></slot>
            <div slot="footer" class="dialog-footer"></div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "MyDialog",
    props: {
        title: {
            type: String,
            default: "提示"
        },
        width: {
            type: String,
            default: "580px"
        },
        visible: {
            type: Boolean,
            default: false
        },
        dialogClose: {
            type: Function,
            default: () => {}
        },
        showClose: {
            type: Boolean,
            default: true
        }
    },

    methods: {
        /**
         * Element UI：传入 before-close 时必须调用 done() 才会真正关闭。
         * 旧代码把父组件 dialogClose 直接绑给 before-close，若未调用 done()，弹窗会关不掉，
         * 且父级 sessionStorage 等清理可能未执行，回到首页会再次弹出。
         */
        handleBeforeClose(done) {
            const fn = this.dialogClose;
            if (typeof fn === "function" && fn.length >= 1) {
                fn(done);
                return;
            }
            if (typeof fn === "function") {
                fn();
            }
            if (typeof done === "function") {
                done();
            }
            this.$emit("update:visible", false);
        },
        onDialogClose() {
            this.$emit("update:visible", false);
        },
        handleCancel() {},
        handleConfirm() {}
    }
};
</script>
<style lang="scss" scoped>
.comp-dialog {
    .el-dialog-contain {
        border-radius: 6px;
        z-index: 2001;
        .el-dialog-my-title {
            display: flex;
            height: 50px;
            .title-content1 {
                margin: 14px 0 14px 20px;
                font-size: 20px;
                font-weight: 500;
                color: var(--color-text-primary);
            }
            .title-content2,
            .title-content3 {
                margin: 18px 0px 18px 8px;
                font-size: 14px;
                font-weight: normal;
                color: var(--color-text-accent);
            }
        }
    }
    :deep(.el-dialog__body) {
        padding: 0 !important;
    }
    :deep(.el-dialog__header) {
        height: 50px;
        border-radius: 6px 6px 0px 0px;
        background: var(--color-divided);
        box-sizing: border-box;
        padding: 0 20px;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .el-dialog__title {
            position: relative;
            font-size: 18px;
            font-weight: bold;
            color: var(--color-text-primary);
        }
        .el-dialog__headerbtn {
            position: relative;
            width: 19.99px;
            height: 19.99px;
            background: var(--color-divided);
            border: 1px solid var(--color-text-accent);
            box-sizing: border-box;
        }
        .el-dialog__headerbtn:hover {
            border: 1px solid var(--color-primary);
        }
        .el-icon-close {
            color: var(--color-text-accent);
        }
        .el-icon-close:hover {
            color: var(--color-primary);
        }
    }
    :deep(.el-dialog__footer) {
        .dialog-footer {
            display: flex;
            justify-content: center;
        }
        .el-button--default {
            width: 180px;
            height: 42px;
            border-radius: 2px;
            background: var(--button-second-bg);
            font-size: 16px;
            color: var(--color-text-regular);
        }
        .el-button--primary {
            width: 180px;
            border-radius: 2px;
            background: var(--color-primary);
            font-size: 16px;
            font-weight: 500;
            color: var(--color-text-white);
        }
    }
    .margin-left-40 {
        margin-left: 40px;
    }
}
</style>
